import { ChangeDetectionStrategy, Component, HostBinding, inject, Input } from '@angular/core';
import { DomSanitizer, type SafeHtml } from '@angular/platform-browser';
import { MTCIcons } from './icons';

type Size = 'xxs' | 'xs' | 'sm' | 'md' | 'lg' | 'xl';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'mtc-custom-icon',
  imports: [],
  templateUrl: './mtc-custom-icon.component.html',
  styleUrl: './mtc-custom-icon.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export default class MTCCustomIconComponent {
  @Input({ required: true }) svgName: keyof typeof MTCIcons = 'back';
  @HostBinding('class') @Input() size: Size = 'md';

  private readonly sanitizer = inject(DomSanitizer);

  get sanitizedSvg(): SafeHtml {
    const svg = MTCIcons[this.svgName];
    return this.sanitizer.bypassSecurityTrustHtml(svg);
  }
}
